/* import __COLOCATED_TEMPLATE__ from './heading-loading-state.hbs'; */
/* RESPONSIBLE TEAM: team-ai-agent-2 */
import templateOnlyComponent from '@ember/component/template-only';

const HeadingLoadingState = templateOnlyComponent();
export default HeadingLoadingState;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'AiAgent::Playground::LoadingStates::HeadingLoadingState': typeof HeadingLoadingState;
  }
}
